module.exports = __webpack_public_path__ + "img/big-list-01.947a4922.jpg";